import React from 'react';
import Logger from '../../util/Logger';
import { connect } from 'react-redux';
import { addNewSelfLaunch, fetchSelfLaunchList } from '../../actions/selfLaunchAllowed';
import User from '../../models/User';
import Creator from '../../models/User';
import { handleEmailErrorsWithDialog, handleError, handleErrorWithDialog } from '../../util/Errors';
import { showDialog } from '../../actions/dialog';
import { UserSorts } from './UserSorts';
import { PulseLoader } from 'react-spinners';
import AuthorizedCreatorListItem from './AuthorizedCreatorListItem';
import { StringUtils } from '../../util/StringUtils';
import './AuthorizedCreators.css';
import Tenant from '../../models/Tenant';
import { arrowDownIcon, arrowUpIcon, PAGE_LINK_RESTRICT_ERROR } from '../../constants';
import LoadingAndPulse from '../shared/LoadingAndPulse';
import ErrorAndRefresh from '../shared/ErrorAndRefresh';
import EmptyState from '../shared/EmptyState';
import WarningIcon from '../../images/warning_red.svg';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';
import { TrackingAnalytics } from '../../analytics/TrackingAnalytics';

class AuthorizedCreators extends React.Component {

  handleEmailChanged = ($event) => {
    const allEmails = $event.target.value;

    this.setState({
      emailString: allEmails
    });
  };
  handleEmailEntryEnded = () => {
    Logger.info(`Email entry complete: ${this.state.emailString}`);
  };
  isAddDisabled = () => {
    const { addLoading } = this.props;
    const { emailString } = this.state;
    return addLoading || !emailString || emailString.length === 0;
  };
  handleAddButtonClick = ($event) => {
    // Don't submit
    $event.preventDefault();

    if (this.isAddDisabled()) {
      // Do nothing
      return;
    }

    // Split the string into a list
    const emails = StringUtils.stringToList(this.state.emailString);
    if (emails && emails.length > 0) {
      const { user, addNewSelfLaunch } = this.props;
      EnterpriseSettings.addCreator();
      addNewSelfLaunch(Tenant.getId(User.getTenant(user)), emails);
    }

    // Clear the text box
    this.setState({
      emailString: ''
    });
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('AuthorizedCreators component cannot be used without a User object');
    }

    this.state = {
      emailString: ''
    };
  }

  componentDidMount () {
    this.fetchAuthorizedCreators();
  }

  fetchAuthorizedCreators = () => {
    const { user, fetchSelfLaunchList } = this.props;
    fetchSelfLaunchList(Tenant.getId(User.getTenant(user)));
  };

  componentDidUpdate (prevProps) {
    const { error, addErrors, addError } = this.props;
    handleError(error, prevProps.error);
    handleErrorWithDialog(addError, prevProps.addError, 'Unable to add new POPin Creator', {
      helpLink: PAGE_LINK_RESTRICT_ERROR
    });
    handleEmailErrorsWithDialog(addErrors, prevProps.addErrors, 'Unable to add Administrators', {
      helpLink: PAGE_LINK_RESTRICT_ERROR
    });

    TrackingAnalytics.handleInvalidEmails(prevProps.addErrors, addErrors,
      EnterpriseSettings.newCreatorsRejected);
  }

  render () {
    const { authorizedCreators, loading, error, addLoading } = this.props;
    const { emailString } = this.state;
    return (
      <div className="no-gutters min-height-card card-authorized-creators">

        <div className="row no-gutters mb-3">
          <div className="text-title my-auto">
            AUTHORIZED POPin CREATORS ({ authorizedCreators ? authorizedCreators.length : 0 })
          </div>
        </div>

        <div className="row creator-email-addresses no-gutters">
          <form
            name="adminEmails"
            className="col-lg-9"
            onSubmit={ this.handleAddButtonClick }>
            <input
              type="text"
              className="pop-input col no-gutters pop-form-control"
              placeholder="Enter email addresses..."
              value={ emailString }
              onBlur={ this.handleEmailEntryEnded }
              onChange={ this.handleEmailChanged } />
          </form>
          <div className="col-lg-2 clearfix">
            <button
              type="button"
              className="btn pop-btn float-right"
              disabled={ this.isAddDisabled() }
              onClick={ this.handleAddButtonClick }>
              { addLoading
                ? <PulseLoader color="#FFFFFF" size={ 10 } />
                : `Add`
              }
            </button>
          </div>
          <div className="col-lg-1" />
        </div>

        <CreatorList
          creators={ authorizedCreators }
          error={ error }
          loading={ loading }
          refresh={ this.fetchAuthorizedCreators } />
      </div>
    );
  }
}

class CreatorList extends React.Component {

  getSortedCreatorList = (creators) => {
    switch (this.state.activeSort) {
      case Sorts.EMAIL_ASCENDING:
        return UserSorts.copySortedByEmail(creators);
      case Sorts.EMAIL_DESCENDING:
        return UserSorts.copySortedByEmail(creators, true);
      case Sorts.DATE_ASCENDING:
        return UserSorts.copySortedByAuthorizedDate(creators);
      case Sorts.DATE_DESCENDING:
        return UserSorts.copySortedByAuthorizedDate(creators, true);
      case Sorts.NAME_ASCENDING:
        return UserSorts.copySortedByName(creators);
      case Sorts.NAME_DESCENDING:
        return UserSorts.copySortedByName(creators, true);
      default:
        Logger.assert('Could not return sorted creator list. Invalid sort: ',
          this.state.activeSort);
    }
  };
  handleSortByName = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.nameSortReversed;
    EnterpriseSettings.sortsCreatorsByName();
    this.setState({
      nameSortReversed: newSort,
      activeSort: newSort ? Sorts.NAME_DESCENDING : Sorts.NAME_ASCENDING
    });
  };
  handleSortByEmail = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.emailSortReversed;
    EnterpriseSettings.sortsCreatorsByEmail();
    this.setState({
      emailSortReversed: newSort,
      activeSort: newSort ? Sorts.EMAIL_DESCENDING : Sorts.EMAIL_ASCENDING
    });
  };
  handleSortByAdded = ($event) => {
    $event.preventDefault();
    const newSort = !this.state.addedSortReversed;
    EnterpriseSettings.sortsCreatorsByAdded();
    this.setState({
      addedSortReversed: newSort,
      activeSort: newSort ? Sorts.DATE_DESCENDING : Sorts.DATE_ASCENDING
    });
  };

  constructor (props) {
    super(props);

    this.state = {
      nameSortReversed: false,
      emailSortReversed: false,
      addedSortReversed: false,
      activeSort: Sorts.NAME_ASCENDING
    };
  }

  render () {
    const { creators, loading, error, refresh } = this.props;
    const sortedCreators = this.getSortedCreatorList(creators);
    const isNameSortActive = (
      this.state.activeSort === Sorts.NAME_ASCENDING ||
      this.state.activeSort === Sorts.NAME_DESCENDING
    );
    const isEmailSortActive = (
      this.state.activeSort === Sorts.EMAIL_ASCENDING ||
      this.state.activeSort === Sorts.EMAIL_DESCENDING
    );
    const isDateSortActive = (
      this.state.activeSort === Sorts.DATE_ASCENDING ||
      this.state.activeSort === Sorts.DATE_DESCENDING
    );

    return (
      <div className="col no-gutters">
        <div className="row pop-list-header creator-list-item">
          <div className="name font-weight-semibold font-size-md">
            <span className="clickable" onClick={ this.handleSortByName }>Name</span>
            <i
              onClick={ this.handleSortByName }
              className={ `material-icons clickable ${isNameSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.nameSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>

          <div className="email font-weight-semibold font-size-md">
            <span className="clickable" onClick={ this.handleSortByEmail }>Email</span>
            <i
              onClick={ this.handleSortByEmail }
              className={ `material-icons clickable ${isEmailSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.emailSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>

          <div className="authorized font-weight-semibold font-size-md">
            <span className="clickable" onClick={ this.handleSortByAdded }>Authorized</span>
            <i
              onClick={ this.handleSortByAdded }
              className={ `material-icons clickable ${isDateSortActive
                ? 'enabled-icon'
                : 'disabled-icon'}` }>
              { this.state.addedSortReversed ? arrowUpIcon : arrowDownIcon }
            </i>
          </div>

          <div className="remove font-weight-semibold font-size-md">
            Remove
          </div>
        </div>

        { error
          ? (
            <div className="creator-list">
              <ErrorAndRefresh
                error="Failed to load Authorized POPin Creators"
                onRefresh={ refresh } />
            </div>
          )
          : loading
            ? (
              <div className="creator-list">
                <LoadingAndPulse
                  size={ 20 }
                  color="#3D9AE2"
                  whatIsLoading="Authorized POPin Creators" />
              </div>
            )
            : (sortedCreators && sortedCreators.length > 0)
              ? (
                <div className="pop-list-container">
                  <div className="col creator-list">
                    { sortedCreators.map(c =>
                      <AuthorizedCreatorListItem key={ Creator.getId(c) } creator={ c } />
                    ) }
                  </div>
                </div>
              ) : (
                <div className="creator-list">
                  <EmptyState
                    image={ WarningIcon }
                    message="No one in your organization can create a POPin until you add users to this authorized list"
                  />
                </div>
              )
        }

      </div>
    );
  }
}

const Sorts = {
  NAME_ASCENDING: 'name',
  NAME_DESCENDING: 'name_reverse',
  EMAIL_ASCENDING: 'email',
  EMAIL_DESCENDING: 'email_reverse',
  DATE_ASCENDING: 'date',
  DATE_DESCENDING: 'date_reverse'
};

const mapStateToProps = state => {
  const user = state.user.user;
  return {
    user: user,
    loading: state.selfLaunchAllowed.loading,
    error: state.selfLaunchAllowed.error,
    authorizedCreators: state.selfLaunchAllowed.heroes,
    addLoading: state.selfLaunchAllowed.addLoading,
    addErrors: state.selfLaunchAllowed.addErrors || [],
    addError: state.selfLaunchAllowed.addError
  };
};

export default connect(mapStateToProps, {
  fetchSelfLaunchList,
  showDialog,
  addNewSelfLaunch
})(AuthorizedCreators);
